module.exports = __webpack_public_path__ + "img/Speaker=Vivian Li.b7d07b77.png";